import partners, { getPartnerUrlHost } from '../partners';
import config from '@cof/ukweb-config/lib/clientConfig';

export const verifyUrlBuilder = ({
    brand,
    quotation,
    consumerName,
    productCode,
    pcr,
    sessionTerminationToken,
    s
}: any) => {
    const verifyUrl = config.get('verifyUrl');
    const redirectToVerifyUrl = new URL(verifyUrl);
    if (brand != partners.DEFAULT) {
        redirectToVerifyUrl.hostname = getPartnerUrlHost(brand, redirectToVerifyUrl.hostname);
    }
    redirectToVerifyUrl.searchParams.set('quotation', quotation);
    const optionalParams = { consumerName, p: productCode, pcr, sessionTerminationToken, s };
    Object.entries(optionalParams).forEach(([key, value]) => {
        if (value) redirectToVerifyUrl.searchParams.set(key, value);
    });
    return redirectToVerifyUrl;
};
